import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-navbar-example',
  templateUrl: './navbar.component.html',
})
export class KitBootstrapNavbarExampleComponent {}
